import type { InferRpcDefinition } from "@redotech/rpc/definition";
// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { groupA } from "./definition-group-a";
import { groupB } from "./definition-group-b";
import { groupC } from "./definition-group-c";
import { groupD } from "./definition-group-d";
import { groupE } from "./definition-group-e";
import { groupF } from "./definition-group-f";
import { groupG } from "./definition-group-g";
import { groupH } from "./definition-group-h";
import { groupI } from "./definition-group-i";
import { groupJ } from "./definition-group-j";
import { groupK } from "./definition-group-k";
import { groupL } from "./definition-group-l";
import { groupM } from "./definition-group-m";
import { groupN } from "./definition-group-n";

// tsgo: explicit annotation needed for TS2742 portability (inferred type references zod/v4/core/util.cjs)
export const rpcDefinition: typeof groupA &
  typeof groupB &
  typeof groupC &
  typeof groupD &
  typeof groupE &
  typeof groupF &
  typeof groupG &
  typeof groupH &
  typeof groupI &
  typeof groupJ &
  typeof groupK &
  typeof groupL &
  typeof groupM &
  typeof groupN = {
  ...groupA,
  ...groupB,
  ...groupC,
  ...groupD,
  ...groupE,
  ...groupF,
  ...groupG,
  ...groupH,
  ...groupI,
  ...groupJ,
  ...groupK,
  ...groupL,
  ...groupM,
  ...groupN,
};

export type RedoInventoryRpcDefinition = InferRpcDefinition<
  typeof rpcDefinition
>;
